import apiClient from './apiClient';

export const getAllProjekte = async (params = {}) => {
  const response = await apiClient.get('/projekte', { params });
  return response.data;
};

export const getProjektById = async (id) => {
  const response = await apiClient.get(`/projekte/${id}`);
  return response.data;
};

export const getProjektStatistiken = async (id) => {
  const response = await apiClient.get(`/projekte/${id}/statistiken`);
  return response.data;
};

export const createProjekt = async (data) => {
  const response = await apiClient.post('/projekte', data);
  return response.data;
};

export const updateProjekt = async (id, data) => {
  const response = await apiClient.put(`/projekte/${id}`, data);
  return response.data;
};

export const deleteProjekt = async (id) => {
  const response = await apiClient.delete(`/projekte/${id}`);
  return response.data;
};

export const addAnfrageToProjekt = async (projektId, anfrageId) => {
  const response = await apiClient.post(`/projekte/${projektId}/anfragen`, { anfrageId });
  return response.data;
};

export const removeAnfrageFromProjekt = async (projektId, anfrageId) => {
  const response = await apiClient.delete(`/projekte/${projektId}/anfragen/${anfrageId}`);
  return response.data;
};

export const addKvaToProjekt = async (projektId, kvaId) => {
  const response = await apiClient.post(`/projekte/${projektId}/kvas`, { kvaId });
  return response.data;
};

export const addRechnungToProjekt = async (projektId, rechnungId) => {
  const response = await apiClient.post(`/projekte/${projektId}/rechnungen`, { rechnungId });
  return response.data;
};

export const addTerminToProjekt = async (projektId, terminId) => {
  const response = await apiClient.post(`/projekte/${projektId}/termine`, { terminId });
  return response.data;
};

export const getProjekteByKunde = async (kundeId) => {
  const response = await apiClient.get(`/projekte/kunde/${kundeId}`);
  return response.data;
};

// === PHASE 2: ERWEITERTE STATISTIKEN ===
export const getErweiterteStatistiken = async (projektId) => {
  const response = await apiClient.get(`/projekte/${projektId}/statistiken/erweitert`);
  return response.data;
};

// === PHASE 2: MATERIALIEN ===
export const getMaterialien = async (projektId) => {
  const response = await apiClient.get(`/projekte/${projektId}/materialien`);
  return response.data;
};

export const getMaterialStatistiken = async (projektId) => {
  const response = await apiClient.get(`/projekte/${projektId}/materialien/statistiken`);
  return response.data;
};

export const addMaterial = async (projektId, data) => {
  const response = await apiClient.post(`/projekte/${projektId}/materialien`, data);
  return response.data;
};

export const updateMaterial = async (projektId, materialId, data) => {
  const response = await apiClient.put(`/projekte/${projektId}/materialien/${materialId}`, data);
  return response.data;
};

export const deleteMaterial = async (projektId, materialId) => {
  const response = await apiClient.delete(`/projekte/${projektId}/materialien/${materialId}`);
  return response.data;
};

// === PHASE 2: MEILENSTEINE ===
export const getMeilensteine = async (projektId) => {
  const response = await apiClient.get(`/projekte/${projektId}/meilensteine`);
  return response.data;
};

export const createMeilenstein = async (projektId, data) => {
  const response = await apiClient.post(`/projekte/${projektId}/meilensteine`, data);
  return response.data;
};

export const updateMeilenstein = async (projektId, meilensteinId, data) => {
  const response = await apiClient.put(`/projekte/${projektId}/meilensteine/${meilensteinId}`, data);
  return response.data;
};

export const deleteMeilenstein = async (projektId, meilensteinId) => {
  const response = await apiClient.delete(`/projekte/${projektId}/meilensteine/${meilensteinId}`);
  return response.data;
};

export const reorderMeilensteine = async (projektId, meilensteinIds) => {
  const response = await apiClient.put(`/projekte/${projektId}/meilensteine/reorder`, { meilensteinIds });
  return response.data;
};

// === PHASE 2: ZEITERFASSUNG ===
export const getZeiterfassungen = async (projektId) => {
  const response = await apiClient.get(`/projekte/${projektId}/zeiterfassung`);
  return response.data;
};

export const getZeitStatistiken = async (projektId) => {
  const response = await apiClient.get(`/projekte/${projektId}/zeiterfassung/statistiken`);
  return response.data;
};

export const addZeiterfassung = async (projektId, data) => {
  const response = await apiClient.post(`/projekte/${projektId}/zeiterfassung`, data);
  return response.data;
};

export const updateZeiterfassung = async (projektId, zeiterfassungId, data) => {
  const response = await apiClient.put(`/projekte/${projektId}/zeiterfassung/${zeiterfassungId}`, data);
  return response.data;
};

export const deleteZeiterfassung = async (projektId, zeiterfassungId) => {
  const response = await apiClient.delete(`/projekte/${projektId}/zeiterfassung/${zeiterfassungId}`);
  return response.data;
};

export const getTerminZeiterfassungen = async (projektId) => {
  const response = await apiClient.get(`/projekte/${projektId}/zeiterfassung/termine`);
  return response.data;
};

export const importTerminZeiterfassung = async (projektId, data) => {
  const response = await apiClient.post(`/projekte/${projektId}/zeiterfassung/import`, data);
  return response.data;
};

// === PHASE 2: GESAMTRECHNUNG ===
export const createGesamtrechnung = async (projektId, data) => {
  const response = await apiClient.post(`/projekte/${projektId}/gesamtrechnung`, data);
  return response.data;
};

// === PHASE 2: FOTOS ===
export const getProjektFotos = async (projektId) => {
  const response = await apiClient.get(`/projekte/${projektId}/fotos`);
  return response.data;
};

export const uploadProjektFoto = async (projektId, formData) => {
  const response = await apiClient.post(`/projekte/${projektId}/fotos`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return response.data;
};

export const deleteProjektFoto = async (projektId, fotoId) => {
  const response = await apiClient.delete(`/projekte/${projektId}/fotos/${fotoId}`);
  return response.data;
};

// === PHASE 2: DOKUMENTE ===
export const getProjektDokumente = async (projektId) => {
  const response = await apiClient.get(`/projekte/${projektId}/dokumente`);
  return response.data;
};

export const uploadProjektDokument = async (projektId, formData) => {
  const response = await apiClient.post(`/projekte/${projektId}/dokumente`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return response.data;
};

export const downloadProjektDokument = async (projektId, dokumentId) => {
  const response = await apiClient.get(`/projekte/${projektId}/dokumente/${dokumentId}/download`, {
    responseType: 'blob'
  });
  return response;
};

export const deleteProjektDokument = async (projektId, dokumentId) => {
  const response = await apiClient.delete(`/projekte/${projektId}/dokumente/${dokumentId}`);
  return response.data;
};

// === PHASE 2: TIMELINE ===
export const getProjektTimeline = async (projektId) => {
  const response = await apiClient.get(`/projekte/${projektId}/timeline`);
  return response.data;
};

// === ÖFFENTLICHER LINK ===
export const generatePublicToken = async (projektId, expiresInDays) => {
  const response = await apiClient.post(`/projekte/${projektId}/public-token`, { expiresInDays });
  return response.data;
};

export const revokePublicToken = async (projektId) => {
  const response = await apiClient.delete(`/projekte/${projektId}/public-token`);
  return response.data;
};
